import { SideModal } from '@wk/components-v3-react16';
import React from 'react';
import { useSidePanel } from './useSidePanel';
import styles from './SidePanel.module.scss';
import { WorkflowPropertiesForm } from './WorkflowPropertiesForm/WorkflowPropertiesForm';

const SidePanel = () => {
  const { isSidePanelOpen, toggleSidePanel } = useSidePanel();

  return (
    <SideModal
      isOpen={isSidePanelOpen}
      onUserRequest={toggleSidePanel}
      flowClass={styles.sidePanel}
    >
      <WorkflowPropertiesForm />
    </SideModal>
  );
};

export default SidePanel;
